import { all, AllEffect } from 'redux-saga/effects';
import SspUsersReducer from './duck/reducer';
import { watchGetSearchSspUsers, watchGetSspUsers } from './duck/saga';

function* SspUsersSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetSspUsers(), watchGetSearchSspUsers()]);
}

export { SspUsersReducer, SspUsersSaga };
